import queryString from 'query-string';
import React from 'react';
import CountUp from 'react-countup';
import { FaFire } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';
import vendorAssign from '../../../../../../assets/custom/v2/vendor.svg';

const ActionBookingCard = ({ actionBooking, cardData, filter, nextNavigation }) => {
  const history = useHistory();

  const totalCount =
    cardData?.[actionBooking?.name]?.data?.totalCount || cardData?.[actionBooking?.name]?.data?.totalCount === 0
      ? Number(cardData?.[actionBooking?.name]?.data?.totalCount)
      : null;

  const routeHandler = () => {
    const params = {
      name: actionBooking?.name,
      type: actionBooking?.type,
      ...(!filter?.timelineFilter && { startDate: filter?.startDate, endDate: filter?.endDate }),
      nextNavigation: nextNavigation,
    };

    if (actionBooking?.nextNavigation) {
      history.push({
        pathname: '/v2/booking',
        search: `?${queryString.stringify(params)}`,
      });
    }
  };
  return (
    <Card
      style={{
        border: '1px solid #FFFFFF',
        borderRadius: '20px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)', // Added boxShadow
        cursor: actionBooking?.nextNavigation && 'pointer',
      }}
      onClick={routeHandler}
      className="status-card"
    >
      <CardBody>
        <div className="d-flex justify-content-between">
          <div>
            {/* <FaFire className="icon-fire" size={20} color="#EA9C2B" /> */}
            <img src={actionBooking?.icon ? actionBooking?.icon : vendorAssign} className="img-fluid" alt="" style={{ width: '50px' }} />
          </div>
          <div>
            <p className="m-0" style={{ fontWeight: '500', fontSize: '16px' }}>
              {actionBooking?.displayName}
            </p>
            <div style={{ textAlign: 'end' }}>
              {totalCount != null ? (
                <CountUp
                  separator=""
                  className="fw-semibold"
                  start={0}
                  end={totalCount}
                  duration={2}
                  style={{ fontSize: '25px', fontWeight: '500' }}
                />
              ) : (
                <p className="fw-bold text-format-3 m-0">-</p>
              )}
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default ActionBookingCard;
